import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var tabsThemeNative = {
  color: 'primary',
  border: colors.cloudGrey,
  background: 'background',
  textColor: 'text',
  fontSize: {
    "default": 'M',
    S: 18,
    L: 23,
    M: 21
  },
  navButton: {
    paddingLeftRight: 32,
    selected: {
      border: {
        width: 4
      }
    },
    unselected: {
      textColor: colors.octoberGrey,
      border: {
        width: 0
      }
    }
  }
};
var tabsThemeWeb = {
  color: 'primary',
  background: 'background',

  /**
   * Gap between the tabs
   */
  gap: 0,
  textColor: 'text',
  borders: {
    radius: 'borders.radius',
    color: colors.cloudGrey
  },
  fontSize: {
    "default": 'M',
    S: 18,
    L: 23,
    M: 21
  },
  inactive: {
    background: 'transparent'
  },
  active: {
    mode: 'underline',
    focusHighlight: 'lighten'
  }
};

var tabsDarkThemeWeb = _extends({}, tabsThemeWeb, {
  borders: _extends({}, tabsThemeWeb.borders, {
    color: colors.mineShaftGrey
  })
});

export { tabsDarkThemeWeb, tabsThemeNative, tabsThemeWeb };